import { prop } from 'ramda';

const SUBDOMAIN = 'subdomain';
const DOMAIN = 'domain';
const S3_BUCKET = 's3_bucket';
const AZURE_STORAGE_BLOB = 'azure_storage_blob';
const AZURE_DATA_LAKE = 'azure_data_lake';
const AWS_ACCOUNT = 'aws_account';
const AZURE_SUBSCRIPTION = 'azure_subscription';
const CLOUDFLARE_ACCOUNT = 'cloudflare_account';
const IP = 'ip';

export const FOUND_IN_REGISTRANT_EMAIL = 'found_in_registrant_email';
export const FOUND_IN_ASN_REGISTRANT_EMAIL = 'found_in_asn_registrant_email';
export const FOUND_BY_REGISTRANT_EMAIL = 'found_by_registrant_email';
export const SAME_REGISTRANT_EMAIL = 'same_registrant_email';
export const FOUND_BY_A_RECORD = 'found_by_a_record';
export const FOUND_BY_SOA_RECORD = 'found_by_soa_record';
export const FOUND_BY_CERTIFICATE = 'found_by_certificate';
export const FOUND_BY_FDNS_RECORD = 'found_by_fdns_record';
export const FOUND_BY_TLDS = 'found_by_tlds';
export const FOUND_BY_WHOIS = 'found_by_whois';
export const FOUND_BY_IPWHOIS = 'found_by_ipwhois';
export const PART_OF_NETBLOCK = 'part_of_netblock';
export const FOUND_BY_NAME = 'found_by_name';
export const FOUND_BY_WORD_LIST = 'found_by_word_list';
export const BELONGS_TO = 'belongs_to';
export const VALIDATED_BY_REGISTRANT_EMAIL = 'validated_by_registrant_email';
export const VALIDATED_BY_A_RECORD = 'validated_by_a_record';
export const VALIDATED_BY_SOA_RECORD = 'validated_by_soa_record';
export const CONNECTED_BY_AZURE_TENANT = 'connected_by_azure_tenant';
export const ASSOCIATED_WITH_CLOUDFLARE_ACCOUNT = 'associated_with_cloudflare_account';

export const itBelongsToACompanyDomain = 'Belongs to company domain';
export const isSimilarToACompanyDomain = 'Similar to company domain';
export const wasRegisteredByTheCompany = 'Registered by company';
export const wasAllocatedToTheCompany = 'Allocated to company';
export const isPartOfACompanySNetblock = 'Part of company netblock';
export const isAssociatedWithAnAmazonCloudAccount = 'Associated with AWS account';
export const isAssociatedWithAnAzureSubscription = 'Associated with Azure subscription';
export const isAssociatedWithACloudflareAccount = 'Associated with Cloudflare Account';
export const isHostedOnACompanyIP = 'Hosted on company IP';
export const itsSOAContactIsACompanyEmailAddress = 'SOA contact is company email';
export const isPartOfANetblockThatWasRegisteredByACompanyEmailAddress =
  'Part of a netblock registered by a company email';
export const wasUsedToRegisterACompanyDomain = 'Registered company domain';
export const belongsToAnASNThatWasRegisteredByACompanyEmailAddress = 'Part of company ASN';
export const wasRegisteredByACompanyEmailAddress = 'Registered by company email';
export const wasRegisteredByTheSameEmailAddressAsACompanyDomain = 'Registered by the same email';
export const wasDetectedAsTheARecordOfACompanyDomain = 'A record of company domain';
export const wasDetectedAsTheARecordOfACompanySubdomain = 'A record of company subdomain';
export const wasDetectedAsTheSOARecordOfACompanyDomain = 'SOA record of company domain';
export const hasListedACompanyDomainInItsCertificate = 'Listed company domain in certificate';
export const itsNameIsIdenticalToACompanyDomain = 'Name identical to company domain';
export const itsNameIsIdenticalToACompanySubdomain = 'Name identical to company subdomain';
export const itsNameIsSimilarToACompanyDomain = 'Name similar to company domain';
export const itConnectedByAzureTenant = 'Office365 Associated Domain';

export const getDiscoveryReasonCloudStorageByName = (type, version) =>
  prop(version)({
    [DISCOVERY_REASON_SHORT]: `Name identical to company  ${type}`,
    [DISCOVERY_REASON_DEFAULT]: `Its name is identical to a company ${type}`,
    [DISCOVERY_REASON_LONG]: `The cloud storage name is identical to a company ${type}`
  });

export const getDiscoveryReasonCloudStorageByWordList = (type, version) =>
  prop(version)({
    [DISCOVERY_REASON_SHORT]: `Name similar to company  ${type}`,
    [DISCOVERY_REASON_DEFAULT]: `Its name is similar to a company ${type}`,
    [DISCOVERY_REASON_LONG]: `The cloud storage name is similar to a company ${type}`
  });

export const DISCOVERY_REASON_SHORT = 'DISCOVERY_REASON_SHORT';
export const DISCOVERY_REASON_DEFAULT = 'DISCOVERY_REASON_DEFAULT';
export const DISCOVERY_REASON_LONG = 'DISCOVERY_REASON_LONG';

export const DISCOVERY_REASON_DISPLAY = {
  [FOUND_IN_REGISTRANT_EMAIL]: {
    [`${DOMAIN}.${IP}`]: {
      [DISCOVERY_REASON_SHORT]: 'Part of company netblock',
      [DISCOVERY_REASON_DEFAULT]: 'Is part of a netblock that was registered by a company email address',
      [DISCOVERY_REASON_LONG]: 'The IP is part of a netblock that was registered by a company email address'
    },
    [`${DOMAIN}.${DOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Registered company domain',
      [DISCOVERY_REASON_DEFAULT]: 'Was used to register a company domain',
      [DISCOVERY_REASON_LONG]: 'The domain was used to register a company domain'
    }
  },
  [FOUND_IN_ASN_REGISTRANT_EMAIL]: {
    [DISCOVERY_REASON_SHORT]: 'Part of company ASN',
    [DISCOVERY_REASON_DEFAULT]: 'Belongs to an ASN that was registered by a company email address',
    [DISCOVERY_REASON_LONG]: 'The netblock belongs to an ASN that was registered by a company email address'
  },
  [FOUND_BY_REGISTRANT_EMAIL]: {
    [DISCOVERY_REASON_SHORT]: 'Registered by company email',
    [DISCOVERY_REASON_DEFAULT]: 'Was registered by a company email address',
    [DISCOVERY_REASON_LONG]: 'The domain was registered by a company email address'
  },
  [SAME_REGISTRANT_EMAIL]: {
    [DISCOVERY_REASON_SHORT]: 'Registered by the same email',
    [DISCOVERY_REASON_DEFAULT]: 'Was registered by the same email address as a company domain',
    [DISCOVERY_REASON_LONG]: 'The domain was registered by the same email address as a company domain'
  },
  [FOUND_BY_A_RECORD]: {
    [`${DOMAIN}.${IP}`]: {
      [DISCOVERY_REASON_SHORT]: 'A record of company domain',
      [DISCOVERY_REASON_DEFAULT]: 'Was detected as the A record of a company domain',
      [DISCOVERY_REASON_LONG]: 'The IP was detected as the A record of a company domain'
    },
    [`${SUBDOMAIN}.${IP}`]: {
      [DISCOVERY_REASON_SHORT]: 'A record of company subdomain',
      [DISCOVERY_REASON_DEFAULT]: 'Was detected as the A record of a company subdomain',
      [DISCOVERY_REASON_LONG]: 'The IP was detected as the A record of a company subdomain'
    }
  },
  [FOUND_BY_SOA_RECORD]: {
    [DISCOVERY_REASON_SHORT]: 'SOA record of company domain',
    [DISCOVERY_REASON_DEFAULT]: 'Was detected as the SOA record of a company domain',
    [DISCOVERY_REASON_LONG]: 'The domain was detected as the SOA record of a company domain'
  },
  [FOUND_BY_CERTIFICATE]: {
    [DISCOVERY_REASON_SHORT]: 'Listed company domain in certificate',
    [DISCOVERY_REASON_DEFAULT]: 'Has listed a company domain in its certificate',
    [DISCOVERY_REASON_LONG]: 'The IP has listed a company domain in its certificate'
  },
  [FOUND_BY_FDNS_RECORD]: {
    [DISCOVERY_REASON_SHORT]: 'Belongs to company domain',
    [DISCOVERY_REASON_DEFAULT]: 'It belongs to a company domain',
    [DISCOVERY_REASON_LONG]: 'The subdomain belongs to a company domain'
  },
  [FOUND_BY_TLDS]: {
    [DISCOVERY_REASON_SHORT]: 'Similar to company domain',
    [DISCOVERY_REASON_DEFAULT]: 'Is similar to a company domain',
    [DISCOVERY_REASON_LONG]: 'The domain is similar to a company domain'
  },
  [FOUND_BY_WHOIS]: {
    [DISCOVERY_REASON_SHORT]: 'Registered by company',
    [DISCOVERY_REASON_DEFAULT]: 'Was registered by the company',
    [DISCOVERY_REASON_LONG]: 'The domain was registered by the company'
  },
  [FOUND_BY_IPWHOIS]: {
    [DISCOVERY_REASON_SHORT]: 'Allocated to company',
    [DISCOVERY_REASON_DEFAULT]: 'Was allocated to the company',
    [DISCOVERY_REASON_LONG]: 'The netblock was allocated to the company'
  },
  [PART_OF_NETBLOCK]: {
    [DISCOVERY_REASON_SHORT]: 'Part of company netblock',
    [DISCOVERY_REASON_DEFAULT]: "Is part of a company's netblock",
    [DISCOVERY_REASON_LONG]: "The IP is part of a company's netblock"
  },
  [FOUND_BY_NAME]: getDiscoveryReasonCloudStorageByName,
  [FOUND_BY_WORD_LIST]: getDiscoveryReasonCloudStorageByWordList,
  [BELONGS_TO]: {
    [`${AWS_ACCOUNT}.${IP}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with AWS account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Amazon cloud account',
      [DISCOVERY_REASON_LONG]: 'The IP is associated with an Amazon cloud account'
    },
    [`${AWS_ACCOUNT}.${DOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with AWS account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Amazon cloud account',
      [DISCOVERY_REASON_LONG]: 'The domain is associated with an Amazon cloud account'
    },
    [`${AWS_ACCOUNT}.${SUBDOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with AWS account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Amazon cloud account',
      [DISCOVERY_REASON_LONG]: 'The subdomain is associated with an Amazon cloud account'
    },
    [`${AWS_ACCOUNT}.${S3_BUCKET}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with AWS account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Amazon cloud account',
      [DISCOVERY_REASON_LONG]: 'The cloud storage is associated with an Amazon cloud account'
    },
    [`${AZURE_SUBSCRIPTION}.${IP}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Azure subscription',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Azure subscription',
      [DISCOVERY_REASON_LONG]: 'The IP is associated with an Azure subscription'
    },
    [`${AZURE_SUBSCRIPTION}.${DOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Azure subscription',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Azure subscription',
      [DISCOVERY_REASON_LONG]: 'The domain is associated with an Azure subscription'
    },
    [`${AZURE_SUBSCRIPTION}.${SUBDOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Azure subscription',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Azure subscription',
      [DISCOVERY_REASON_LONG]: 'The subdomain is associated with an Azure subscription'
    },
    [`${AZURE_SUBSCRIPTION}.${AZURE_DATA_LAKE}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Azure subscription',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Azure subscription',
      [DISCOVERY_REASON_LONG]: 'The cloud storage is associated with an Azure subscription'
    },
    [`${AZURE_SUBSCRIPTION}.${AZURE_STORAGE_BLOB}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Azure subscription',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with an Azure subscription',
      [DISCOVERY_REASON_LONG]: 'The cloud storage is associated with an Azure subscription'
    }
  },
  [VALIDATED_BY_REGISTRANT_EMAIL]: {
    [DISCOVERY_REASON_SHORT]: 'Registered by company email',
    [DISCOVERY_REASON_DEFAULT]: 'Was registered by a company email address',
    [DISCOVERY_REASON_LONG]: 'The domain was registered by a company email address'
  },
  [VALIDATED_BY_A_RECORD]: {
    [DISCOVERY_REASON_SHORT]: 'Hosted on company IP',
    [DISCOVERY_REASON_DEFAULT]: 'Is hosted on a company IP',
    [DISCOVERY_REASON_LONG]: 'The domain is hosted on a company IP'
  },
  [VALIDATED_BY_SOA_RECORD]: {
    [DISCOVERY_REASON_SHORT]: 'SOA contact is company email',
    [DISCOVERY_REASON_DEFAULT]: 'Its SOA contact is a company email address',
    [DISCOVERY_REASON_LONG]: "The domain's SOA contact is a company email address"
  },
  [CONNECTED_BY_AZURE_TENANT]: {
    [DISCOVERY_REASON_SHORT]: 'Office365 Associated Domain',
    [DISCOVERY_REASON_DEFAULT]: 'Office365 Associated Domain',
    [DISCOVERY_REASON_LONG]: 'Office365 Associated Domain'
  },
  [ASSOCIATED_WITH_CLOUDFLARE_ACCOUNT]: {
    [`${CLOUDFLARE_ACCOUNT}.${IP}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Cloudflare Account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with a Cloudflare Account',
      [DISCOVERY_REASON_LONG]: 'The IP is associated with a Cloudflare Account'
    },
    [`${CLOUDFLARE_ACCOUNT}.${DOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Cloudflare Account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with a Cloudflare Account',
      [DISCOVERY_REASON_LONG]: 'The domain is associated with a Cloudflare Account'
    },
    [`${CLOUDFLARE_ACCOUNT}.${SUBDOMAIN}`]: {
      [DISCOVERY_REASON_SHORT]: 'Associated with Cloudflare Account',
      [DISCOVERY_REASON_DEFAULT]: 'Is associated with a Cloudflare Account',
      [DISCOVERY_REASON_LONG]: 'The subdomain is associated with a Cloudflare Account'
    }
  }
};

export const MANUAL = 'Manual';

export const DISCOVERED_BY_WHOIS = 'Whois';
export const DISCOVERED_BY_DNS = 'DNS';
export const DISCOVERED_BY_NETBLOCK = 'Netblock';
export const DISCOVERED_BY_CLOUD_SEARCH = 'Cloud Search';
export const DISCOVERED_BY_CERTIFICATE = 'Certificate';
export const DISCOVERED_BY_INTEGRATION = 'Integration';
export const AZURE = 'Office365';
export const NAME_SIMILARITY = 'Name Similarity';

export const DISCOVERY_REASON_SIMPLE_MAPPING = {
  [FOUND_IN_REGISTRANT_EMAIL]: DISCOVERED_BY_NETBLOCK,
  [FOUND_IN_ASN_REGISTRANT_EMAIL]: DISCOVERED_BY_NETBLOCK,
  [FOUND_BY_REGISTRANT_EMAIL]: DISCOVERED_BY_WHOIS,
  [SAME_REGISTRANT_EMAIL]: DISCOVERED_BY_WHOIS,
  [FOUND_BY_A_RECORD]: DISCOVERED_BY_DNS,
  [FOUND_BY_SOA_RECORD]: DISCOVERED_BY_DNS,
  [FOUND_BY_CERTIFICATE]: DISCOVERED_BY_CERTIFICATE,
  [FOUND_BY_FDNS_RECORD]: DISCOVERED_BY_DNS,
  [FOUND_BY_TLDS]: NAME_SIMILARITY,
  [FOUND_BY_WHOIS]: DISCOVERED_BY_WHOIS,
  [FOUND_BY_IPWHOIS]: DISCOVERED_BY_NETBLOCK,
  [PART_OF_NETBLOCK]: DISCOVERED_BY_DNS,
  [FOUND_BY_NAME]: DISCOVERED_BY_CLOUD_SEARCH,
  [FOUND_BY_WORD_LIST]: DISCOVERED_BY_CLOUD_SEARCH,
  [BELONGS_TO]: DISCOVERED_BY_INTEGRATION,
  [VALIDATED_BY_REGISTRANT_EMAIL]: DISCOVERED_BY_WHOIS,
  [VALIDATED_BY_A_RECORD]: DISCOVERED_BY_DNS,
  [VALIDATED_BY_SOA_RECORD]: DISCOVERED_BY_WHOIS,
  [CONNECTED_BY_AZURE_TENANT]: AZURE,
  [ASSOCIATED_WITH_CLOUDFLARE_ACCOUNT]: DISCOVERED_BY_INTEGRATION
};
